import PatchLevelBadge from './PatchLevelBadge';

// Base configuration class
class FailedIssueTableConfig {
    getDefaultVisibleContent() {
        throw new Error('getDefaultVisibleContent must be implemented');
    }

    getColumnDefinitions() {
        throw new Error('getColumnDefinitions must be implemented');
    }

    getVisibleContentOptions() {
        throw new Error('getVisibleContentOptions must be implemented');
    }

    getFilterableFields(issue) {
        throw new Error('getFilterableFields must be implemented');
    }

    getTypeName() {
        throw new Error('getTypeName must be implemented');
    }
}

// Jira-specific configuration
class JiraFailedIssueTableConfig extends FailedIssueTableConfig {
    getDefaultVisibleContent() {
        return ["error", "project", "component", "summary", "patch_level"];
    }

    getColumnDefinitions() {
        return [
            {
                id: "project",
                header: "Project",
                cell: (item) => item.project ? item.project : '--'
            },
            {
                id: "component",
                header: "Component",
                cell: (item) => item.component ? item.component : '--'
            },
            {
                id: "summary",
                header: "Summary",
                cell: (item) => item.summary ? item.summary : '--'
            },
            {
                id: "patch_level",
                header: "Type",
                cell: (item) => <PatchLevelBadge patch_level={item.patch_level} />
            },
            {
                id: "error",
                header: "Error",
                cell: (item) => item.error ? item.error : '--' 
            }
        ];
    }

    getVisibleContentOptions() {
        return [
            {
                label: "Fields",
                options: [
                    { id: "error", label: "Error" },
                    { id: "project", label: "Project" },
                    { id: "component", label: "Component" },
                    { id: "summary", label: "Summary" },
                    { id: "patch_level", label: "Type" }
                ]
            }
        ];
    }

    getFilterableFields(issue) {
        return [
            issue.error ? issue.error.toLowerCase() : '',
            issue.summary ? issue.summary.toLowerCase() : '',
            issue.project ? issue.project.toLowerCase() : '',
            issue.component ? issue.component.toLowerCase() : ''
        ];
    }

    getTypeName() {
        return 'Jira(s)';
    }
}

// Shepherd-specific configuration
class ShepherdFailedIssueTableConfig extends FailedIssueTableConfig {
    getDefaultVisibleContent() {
        return ["error", "bindle_id", "summary", "patch_level"];
    }

    getColumnDefinitions() {
        return [
            {
                id: "bindle_id",
                header: "Bindle ID",
                cell: (item) => item.bindle_id ? item.bindle_id : '--'
            },
            {
                id: "summary",
                header: "Summary",
                cell: (item) => item.summary ? item.summary : '--'
            },
            {
                id: "patch_level",
                header: "Type",
                cell: (item) => <PatchLevelBadge patch_level={item.patch_level} />
            },
            {
                id: "error",
                header: "Error",
                cell: (item) => item.error ? item.error : '--' 
            }
        ];
    }

    getVisibleContentOptions() {
        return [
            {
                label: "Fields",
                options: [
                    { id: "error", label: "Error" },
                    { id: "bindle_id", label: "Bindle ID" },
                    { id: "summary", label: "Summary" },
                    { id: "patch_level", label: "Patch Level" }
                ]
            }
        ];
    }

    getFilterableFields(issue) {
        return [
            issue.error ? issue.error.toLowerCase() : '',
            issue.bindle_id ? issue.bindle_id.toLowerCase() : '',
            issue.summary ? issue.summary.toLowerCase() : '',
            issue.patch_level ? issue.patch_level.toLowerCase() : ''
        ];
    }

    getTypeName() {
        return 'Shepherd Issue(s)';
    }
}

// Factory function to get the appropriate config
export function getFailedIssueTableConfig(issueType) {
    switch (issueType) {
        case 'shepherd':
            return new ShepherdFailedIssueTableConfig();
        case 'jira':
        default:
            return new JiraFailedIssueTableConfig();
    }
}
